import React, { useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import AddFAQ from "../Faq/AddFAQ";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import EditFAQ from "../Faq/EditFAQ";
import DeleteFaqModal from "../Faq/DeleteFaqModal";
import { canPerformAction } from "../../utils/denyAccess";
const initialState = {
  showAddFaq: false,
  showEditFaq: false,
  showDeleteFaq: false,
};
const FAQ = () => {
  const [iState, setUpdateState] = useState(initialState);
  const [faqData, setFaqData] = useState({});
  const dispatch = useDispatch();
  const { loading, faq } = useSelector((state) => state?.FAQ);
  const { showAddFaq, showEditFaq, showDeleteFaq } = iState;
  const handleShowAddFaq = () => {
    setUpdateState({ ...iState, showAddFaq: true });
  };
  const handleEditShow = (e, res) => {
    e.stopPropagation();
    setFaqData(res);
    setUpdateState((prev) => ({ ...prev, showEditFaq: true }));
  };
  const handleDeleteShow = (e, res) => {
    e.stopPropagation();
    setFaqData(res);
    setUpdateState((prev) => ({ ...prev, showDeleteFaq: true }));
  };
  return (
    <>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "5px",
          alignItems: "center",
        }}
      >
        <h6>FAQ</h6>
        {canPerformAction("Static-Content") && (
          <button
            style={{
              borderRadius: "5px",
              padding: "10px 15px",
              backgroundColor: "#ffbf43",
              color: "white",
              border: "none",
            }}
            onClick={handleShowAddFaq}
          >
            ADD FAQ
          </button>
        )}
      </div>
      <Accordion defaultActiveKey="0">
        {faq?.addData
          ?.slice()
          .reverse()
          .map((res, i) => {
            return (
              <Accordion.Item eventKey={i} className="mb-3" key={res?._id}>
                <Accordion.Header>
                  <div
                    className="d-flex justify-content-between"
                    style={{
                      width: "100%",
                      marginRight: "10px",
                      alignItems: "center",
                    }}
                  >
                    <h6>{res?.question}</h6>
                    {canPerformAction("Static-Content") && (
                      <>
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            gap: "10px",
                          }}
                        >
                          <a onClick={(e) => handleEditShow(e, res)}>
                            <i className="fa-regular fa-pen-to-square" />
                          </a>
                          <a onClick={(e) => handleDeleteShow(e, res)}>
                            <i className="fa-solid fa-trash"></i>
                          </a>
                        </div>
                      </>
                    )}
                  </div>
                </Accordion.Header>
                <Accordion.Body>{res?.answer}</Accordion.Body>
              </Accordion.Item>
            );
          })}
      </Accordion>
      {showAddFaq && <AddFAQ setUpdateState={setUpdateState} />}
      {showEditFaq && (
        <EditFAQ setUpdateState={setUpdateState} faqData={faqData} />
      )}
      {showDeleteFaq && (
        <DeleteFaqModal setUpdateState={setUpdateState} faqData={faqData} />
      )}
    </>
  );
};

export default FAQ;
